import React from "react";

const HORIZONTAL = "https://customer-assets-jt897jd0.emergentagent.net/job_tracey-hub/artifacts/djmxnfow_4.png";
const STACKED = "https://customer-assets-jt897jd0.emergentagent.net/job_tracey-hub/artifacts/5ily1h15_3.png";

// Real GK Team x Signature logo. Pass variant="stacked" for the vertical logo.
export default function GkLogo({ variant = "horizontal", className = "" }) {
  const src = variant === "stacked" ? STACKED : HORIZONTAL;
  const fallback = variant === "stacked" ? "h-24 w-auto" : "h-9 w-auto";
  return (
    <img
      src={src}
      alt="The GK Team at Signature"
      className={`${className || fallback} object-contain`}
      draggable={false}
    />
  );
}
